// extracted by mini-css-extract-plugin
export default {"MainBody":"Activation_MainBody__73ile","imageContainer":"Activation_imageContainer__94gKz","buttonContainer":"Activation_buttonContainer__ydX1C"};